<template>
  <div>
    <v-container class="maxContainerWidth">
      <MyBeneficiary
        v-if="beneficiaryStep === 1"
        @set-type="setBeneType"
        @set-beneficiary="setBeneficiary"
        :coming-from-edit-beneficiary="getIsComingFromEditBeneficiary"
      />
      <EditBeneficiaryDetails
        v-if="beneficiaryStep === 2 || beneficiaryStep === 3"
        :bene-type="getBeneType"
        :bene-obj="getBeneficiary"
        @cancel="isComingFromEditBeneficiary = true"
      />
      <ConfirmBeneficiary v-if="beneficiaryStep === 4" />
      <NavigationConfirmationDialog
        v-if="showNavigationConfirmationDialog"
        @confirm-navigation="navigateToRoute"
        @cancel-navigation="showNavigationConfirmationDialog = false"
      />
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
// import { required, maxLength } from '@vuelidate/validators';
import MyBeneficiary from './MyBeneficiary.vue';
import EditBeneficiaryDetails from './EditBeneficiaryDetails.vue';
import ConfirmBeneficiary from './ConfirmBeneficiary.vue';
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import type { IGetBeneficiariesResponse } from '@/shared/api/models.bff';
import NavigationConfirmationDialog from '@/components/NavigationConfirmation/NavigationConfirmationDialog.vue';
import type { RouteParamsGeneric } from 'vue-router';

const componentOptions: ComponentOptions = {
  name: 'UpdateBeneficiary',
  components: {
    MyBeneficiary,
    EditBeneficiaryDetails,
    ConfirmBeneficiary,
    NavigationConfirmationDialog,
  },
  data: () => ({
    beneType: '',
    beneficiary: {},
    editing: false,
    isComingFromEditBeneficiary: false,
    showNavigationConfirmationDialog: false,
    navigatingToRoute: '',
    navigatingToParams: {} as RouteParamsGeneric,
    navigationAwayConfirmed: false,
  }),
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, {
      beneficiaryStep: 'beneficiaryStep',
    }),
    getBeneType() {
      return this.beneType;
    },
    getBeneficiary() {
      return this.beneficiary;
    },
    getIsComingFromEditBeneficiary() {
      return this.isComingFromEditBeneficiary;
    },
  },
  methods: {
    ...mapActions(usePolicyStore, {
      setBeneficiaryStep: 'setBeneficiaryStep',
    }),
    setBeneType(val: string) {
      this.beneType = val;
    },
    setBeneficiary(val: IGetBeneficiariesResponse) {
      this.beneficiary = val;
    },
    navigateToRoute() {
      this.navigationAwayConfirmed = true;
      this.$router.push({
        name: this.navigatingToRoute,
        params: this.navigatingToParams,
      });
    },
  },
  beforeRouteLeave(to, _, next) {
    const isProcessDone = this.beneficiaryStep === -1 || this.navigationAwayConfirmed;
    // const navigatingOutsideMinorAccountLink =
    //   to.name !== RouteNames.MINOR_ACCOUNT_LINK_PROCESS &&
    //   to.path !== '/minor-account-link-process';
    // navigatingOutsideMinorAccountLink &&
    if (!isProcessDone) {
      this.showNavigationConfirmationDialog = true; // show NavigationConfirmationDialog
      this.navigatingToRoute = to.name as string; // save the route name
      this.navigatingToParams = to.params;
      next(false); // cancel the navigation
    } else {
      this.setBeneficiaryStep(-1); // reset the step when navigation happens
      next();
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.maxContainerWidth {
  max-width: 1024px !important;
  margin: auto;
}
.move-right {
  float: right;
}

.bkgrnd-color-white {
  background-color: #ffffff;
}

.bkgrnd-color-blue-white {
  background-color: #f2f2f2;
}

.blue-bkgrnd {
  background-color: #c9e5f9;
}

.buttonFormat {
  width: 300px;
  height: 44px;
  font-size: 18px;
  font-weight: 600;
}

.sm-pl-5 {
  @media (min-width: 576px) {
    /* Adjusting for small screen and up */
    padding-left: 40px;
  }
}

@media (min-width: 768px) {
  /* Adjusting for medium screen and up */
  .pad-left-md {
    padding-left: 12px;
  }

  .pad-right-md {
    padding-right: 12px;
  }
}

.blue-border {
  border: solid 2px #2196f3;
  cursor: pointer;
}

.select-address {
  color: #2196f3 !important;
}

:deep(label.v-label--active) {
  font-weight: 500;
  color: #333;
}

:deep(div.v-input) {
  padding-bottom: 12px;
}

h3.heading_three.font-weight-medium {
  font-weight: 500 !important;
}

.font-size-md {
  font-size: 16px !important;
}

.inlineText {
  display: inline-block;
}

button.short {
  height: 40px !important;
  text-transform: none !important;
  box-shadow: none !important;
  border: 1px #063562 solid;
  width: auto !important;
}
</style>
